/**
 * Textos do "Escolha o seu município" (D3; components/MyCityPicker), PARA APROVAR. Vieram de `copy/home.ts` sem mudança
 * de chave nem de texto (§72): o campo entrou no JS crítico (a pré-apuração o recebe do `phaseScreen`), e o catálogo
 * inteiro da página inicial não precisa ir junto.
 */
import { type CopyVars, interpolate } from './strings';

export const MY_CITY_STRINGS = {
  'home.mycity.title': 'Escolha o seu município',
  'home.mycity.placeholder': 'Nome do município',
  'home.mycity.note': 'Fica guardado só neste aparelho.',
  'home.mycity.chosen': 'Seu município: {CIDADE}',
  'home.mycity.go': 'Ver {CIDADE}',
  'home.mycity.forget': 'Esquecer',
} as const satisfies Record<string, string>;

export type MyCityCopyKey = keyof typeof MY_CITY_STRINGS;

/** t() do campo da cidade: mesma interpolação de strings.ts. */
export function tMyCity(key: MyCityCopyKey, vars: CopyVars = {}): string {
  return interpolate(key, MY_CITY_STRINGS[key], vars);
}
